module.exports = __webpack_public_path__ + "static/media/intellectual (1).b138e111.svg";